
import { Component, Vue } from 'vue-property-decorator';
import SelectedManufacturer from '../components/selected-manufacturer.vue';
import Daily from './daily.vue';

@Component({
    components: { SelectedManufacturer, Daily }
})
export default class DailysWrapper extends Vue {
    get hasBrand(): boolean {
        return !!this.$route.query.marca;
    }

    get marcaSeleccionada(): string {
        return this.$route.query.marca as string;
    }

    handleBrandSelected(brand: string) {
        this.$router.push({ query: { marca: brand } });
    }

    handleGoBack() {
        this.$router.replace({ query: {} });
    }
}
